import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import no from './locales/no.json';
import en from './locales/en.json';

const savedLang = localStorage.getItem('storybits-lang') || 'no';

i18n.use(initReactI18next).init({
  resources: {
    no: { translation: no },
    en: { translation: en },
  },
  lng: savedLang,
  fallbackLng: 'no',
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

export default i18n;
